<app-header></app-header>
<app-sidebar
ativo="Tarefas"
></app-sidebar>
<div class="content-wrapper">
  <section class="content">
    <app-breadcrumb
      Titulo="Minhas tarefas"
      Pagina="Minhas tarefas"
    ></app-breadcrumb>
    <div class="row">
      <div class="conteudo-kanbam">
        <!-- Coluna A fazer -->
        <div class="coluna-kanbam" (dragover)="onDragOver($event, 1)" (drop)="onDrop($event, 1)">
          <div class="col-md-12">
            <div class="card card-titulo">
              <div class="row cor-inicial">
                <div class="col-md-10">
                  <div class="texto-status" style="margin-left: 50px;">A fazer
                    <p class="texto-valor" *ngIf="listaTarefasFazer.itens.length > 0">{{ listaTarefasFazer.itens.length }} tarefas</p>
                    <p class="texto-valor" *ngIf="listaTarefasFazer.itens.length == 0"> - </p>
                  </div>
                </div>
                <div class="col-md-2">
                  <i class="fa fa-plus-circle cor-inicial icone-titulo" (click)="showModalNovo()"></i>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12 card p-3 card-atendimento"
               *ngFor="let tarefa of listaTarefasFazer.itens"
               draggable="true"
               (dragstart)="onDragStart($event, tarefa)"
               (click)="buscarDetalheTarefa(tarefa.id)">
            <div class="linha cor-inicial"></div>
            <div class="row" style="margin-top: 10px">
              <div class="texto-nome"><span class="tarefa-id">#{{tarefa.id}}</span>{{ tarefa.descricao }}</div>
            </div>
            <div class="row" style="margin-top: 10px">
              <p class="texto-quebra"><i style="width: 20px" class="fa fa-user"></i>Responsável: {{ tarefa.responsavel }}</p>
            </div>
            <div class="row rodape-atendimento">
              <div class="col-md-8 d-flex align-items-center justify-content-start" style="height: 40px;">
                <p class="texto-data" style="margin-top: 25px">
                  <i style="width: 15px" class="fa fa-calendar"></i> {{ tarefa.dataCadastro | date: 'dd MMM yyyy' }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- Coluna Em andamento -->
        <div class="coluna-kanbam" (dragover)="onDragOver($event, 2)" (drop)="onDrop($event, 2)">
          <div class="col-md-12">
            <div class="card card-titulo">
              <div class="row cor-agendado">
                <div class="col-md-10">
                  <div class="texto-status" style="margin-left: 75px;">Em andamento
                    <p class="texto-valor" *ngIf="listaTarefasEmAndamento.itens.length > 0">{{ listaTarefasEmAndamento.itens.length }} tarefas</p>
                    <p class="texto-valor" *ngIf="listaTarefasEmAndamento.itens.length == 0"> - </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12 card p-3 card-atendimento"
               *ngFor="let tarefa of listaTarefasEmAndamento.itens"
               draggable="true"
               (dragstart)="onDragStart($event, tarefa)"
               (click)="buscarDetalheTarefa(tarefa.id)">
            <div class="linha cor-agendado"></div>
            <div class="row" style="margin-top: 10px">
              <div class="texto-nome"><span class="tarefa-id">#{{tarefa.id}}</span>{{ tarefa.descricao }}</div>
            </div>
            <div class="row" style="margin-top: 10px">
              <p class="texto-quebra"><i style="width: 20px" class="fa fa-user"></i>Responsável: {{ tarefa.responsavel }}</p>
           </div>
            <div class="row rodape-atendimento">
              <div class="col-md-8 d-flex align-items-center justify-content-start" style="height: 40px;">
                <p class="texto-data" style="margin-top: 25px">
                  <i style="width: 15px" class="fa fa-calendar"></i> {{ tarefa.dataCadastro | date: 'dd MMM yyyy' }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- Coluna Validação -->
        <div class="coluna-kanbam" (dragover)="onDragOver($event, 3)" (drop)="onDrop($event, 3)">
          <div class="col-md-12">
            <div class="card card-titulo">
              <div class="row cor-aprovacao">
                <div class="col-md-10">
                  <div class="texto-status" style="margin-left: 50px;">Validação
                    <p class="texto-valor" *ngIf="listaTarefasVerificacao.itens.length > 0">{{ listaTarefasVerificacao.itens.length }} tarefas</p>
                    <p class="texto-valor" *ngIf="listaTarefasVerificacao.itens.length == 0"> - </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12 card p-3 card-atendimento"
               *ngFor="let tarefa of listaTarefasVerificacao.itens"
               draggable="true"
               (dragstart)="onDragStart($event, tarefa)"
               (click)="buscarDetalheTarefa(tarefa.id)">
            <div class="linha cor-aprovacao"></div>
            <div class="row" style="margin-top: 10px">
              <div class="texto-nome"><span class="tarefa-id">#{{tarefa.id}}</span>{{ tarefa.descricao }}</div>
            </div>
            <div class="row" style="margin-top: 10px">
              <p class="texto-quebra"><i style="width: 20px" class="fa fa-user"></i>Responsável: {{ tarefa.responsavel }}</p>
           </div>
            <div class="row rodape-atendimento">
              <div class="col-md-8 d-flex align-items-center justify-content-start" style="height: 40px;">
                <p class="texto-data" style="margin-top: 25px">
                  <i style="width: 15px" class="fa fa-calendar"></i> {{ tarefa.dataCadastro | date: 'dd MMM yyyy' }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- Coluna Fechado -->
        <div class="coluna-kanbam" (dragover)="onDragOver($event, 4)" (drop)="onDrop($event, 4)">
          <div class="col-md-12">
            <div class="card card-titulo">
              <div class="row cor-finalizado">
                <div class="col-md-10">
                  <div class="texto-status" style="margin-left: 50px;">Fechado
                    <p class="texto-valor" *ngIf="listaTarefasFechada.itens.length > 0">{{ listaTarefasFechada.itens.length }} tarefas</p>
                    <p class="texto-valor" *ngIf="listaTarefasFechada.itens.length == 0"> - </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12 card p-3 card-atendimento"
               *ngFor="let tarefa of listaTarefasFechada.itens"
               draggable="true"
               (dragstart)="onDragStart($event, tarefa)"
               (click)="buscarDetalheTarefa(tarefa.id)">
            <div class="linha cor-finalizado"></div>
            <div class="row" style="margin-top: 10px">
              <div class="texto-nome"><span class="tarefa-id">#{{tarefa.id}}</span>{{ tarefa.descricao }}</div>
            </div>
            <div class="row" style="margin-top: 10px">
              <p class="texto-quebra"><i style="width: 20px" class="fa fa-user"></i>Responsável: {{ tarefa.responsavel }}</p>
              <p class="texto-quebra" *ngIf="tarefa.dataFinalizacao && tarefa.status == 4"><i style="width: 20px" class="fa fa-calendar"></i> Data de finalização: {{ tarefa.dataFinalizacao | date: 'dd MMM yyyy' }}</p>
            </div>
            <div class="row rodape-atendimento">
              <div class="col-md-8 d-flex align-items-center justify-content-start" style="height: 40px;">
                <p class="texto-data" style="margin-top: 25px">
                  <i style="width: 15px" class="fa fa-calendar"></i> {{ tarefa.dataCadastro | date: 'dd MMM yyyy' }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
<app-novo-compromisso (atualizarListaPai)="buscarLista()">
</app-novo-compromisso>
<app-detalhes-tarefas
  [showModal] = "showModalDetalhes"
  (fecharModalPai)="fecharModalDetalhes()"
  (atualizarListaPai)="buscarLista()"
></app-detalhes-tarefas>
